import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import embeddedIcon from './embeddedIcon.svg';
import embeddedIconSelected from './embeddedIconSelected.svg';
import "./menu-bar.css";
import PropTypes from 'prop-types';
import {toast} from 'react-hot-toast';
// import {message} from 'antd';

// 新建文件类组件
class AIMenuItem extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleMouseEnter',
            'handleMouseLeaveOuter',
            'handleMouseLeave',
            'handleAIMenu'
        ]);
        this.ref = React.createRef();
        this.state = {
            AIMenuState: false
        }
        this.timer = null
    }

    componentDidMount () {
        if (!('ontouchstart' in window)) {
            this.ref.current.addEventListener(
                'mouseenter',
                this.props.onClickEdit
            );
            this.ref.current.addEventListener(
                'mouseleave',
                this.props.onRequestCloseEdit
            );
        }
    }

    componentWillUnmount () {
        this.ref.current.removeEventListener(
            'mouseenter',
            this.props.onClickEdit
        );
        this.ref.current.removeEventListener(
            'mouseleave',
            this.props.onRequestCloseEdit
        );
    }
    // 点击跳转
    handleAIMenu(type) {
        const url = new URL(window.location.origin);
        url.searchParams.set('routeId', type);
        window.location.href = url.toString();
        // window.location.href = 'http://192.168.0.199:3300/build/' 


    }
    handleMouseEnter () {
        clearTimeout(this.timer);
        this.setState({
            AIMenuState: true
        })
    }
    handleMouseLeaveOuter () {
        this.timer = setTimeout(() => {
            this.setState({
                AIMenuState: false
            })
        }, 200);
    }
    handleMouseLeave () {
        this.setState({
            AIMenuState: false
        })
    }
    render() {
        return (
            <div>
                <div
                    ref={this.ref}
                    // className={this.state.AIMenuState ? 'menuBarItemSelect' : 'menuBarItem'}
                    className={'menuBarItem'}
                    onClick={() => this.handleAIMenu('TinyML')}
                >
                    {/* AI */}
                    <FormattedMessage
                        defaultMessage="TinyML"
                        id="meun-item-aiproject"
                    />
                </div>
            </div>

        );
    }
}

export default AIMenuItem;
